/*
 * Values come from .env at build time (see webpack.config.js DefinePlugin).
 * Copy .env.example to .env and fill in the Azure AD app registration values.
 * See README.md "Azure AD setup" section for exact steps.
 */
export const msalConfig = {
  auth: {
    clientId: process.env.ADDIN_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.ADDIN_TENANT_ID}`,
    redirectUri: process.env.ADDIN_REDIRECT_URI,
  },
  cache: {
    // localStorage (not sessionStorage) so a reopened task pane within the SAME host app
    // doesn't need a fresh interactive popup. Doesn't help across host apps (Excel vs Word
    // each have their own isolated WebView2 storage) -- that's what Office SSO is for, see
    // ensureSignedIn() in taskpane.js.
    cacheLocation: "localStorage",
  },
};

// Delegated Graph scope needed to send mail as the signed-in user.
export const graphScopes = ["Mail.Send", "User.Read"];

// Only requested on top of graphScopes when the user opts into OneDrive archiving --
// keeps the extra consent prompt scoped to people who actually use that feature.
export const oneDriveScopes = ["Files.ReadWrite"];

export const backendUrl = process.env.ADDIN_BACKEND_URL;

// tid Microsoft assigns to every personal Microsoft account -- including ones that use a
// non-Microsoft address (gmail.com, yahoo.com, ...) as their sign-in name, since Microsoft lets
// you register any email as an MSA username. Fixed value, never a real Entra tenant. Not itself
// a reason to block sign-in (see MICROSOFT_CONSUMER_MAILBOX_DOMAIN below for what actually
// matters) -- just how isUnsupportedAccount() in taskpane.js recognizes "this is a personal
// account" in the first place. Mirrored server-side in packages/backend/src/graph.ts.
export const PERSONAL_ACCOUNT_TENANT_ID = "9188040d-6c67-4c5b-b112-36a304b66dad";

// A personal Microsoft account signed in with an outlook.com/hotmail.com/live.com/msn.com
// address *is* its own Microsoft-hosted mailbox, so Graph Mail.Send works on it same as a
// work/school account. A personal account signed in with a non-Microsoft address (gmail.com,
// yahoo.com, ...) only has a hidden, often never-provisioned Outlook mailbox behind it -- Graph
// sendMail fails on those with ErrorMailboxNotEnabledForRESTAPI, which is exactly what breaks a
// mail-merge batch partway through. So the dividing line is mailbox domain, not personal-vs-org.
// Mirrored server-side in packages/backend/src/graph.ts.
export const MICROSOFT_CONSUMER_MAILBOX_DOMAIN = /^(outlook|hotmail|live|msn|passport)\.[a-z.]{2,}$/i;
